var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hasLoaded && _setup.bfh)?_c('div',[_c('div',{staticClass:"bfh-section"},[_c('BaseSection',[_c(_setup.BfhsTile,{attrs:{"bfh":_setup.bfh}})],1)],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }